import { ACH } from './constants';
import { formatCurrency } from '@/utils/common/formatting';
import { getPaymentMethodLabel } from './labels';
import { formatConvenienceFee } from './labels';

export const generatePaymentSummaryRows = (
  isOwner: boolean,
  residentName: string,
  paymentMethod: any,
  balanceDue: number,
  convenienceFee: number,
  totalCharge: number,
): Array<[string, string]> => {
  const methodLabel = getPaymentMethodLabel(paymentMethod);
  const totalChargesMessage = paymentMethod?.type === ACH
    ? `Total ACH charges for ${paymentMethod.name || 'Account'}`
    : `Total charges to ${methodLabel}`;

  const baseRows: Array<[string, string]> = [
    ['Payment amount', formatCurrency(balanceDue)],
    ['Fee', formatConvenienceFee(convenienceFee)],
    [totalChargesMessage, formatCurrency(totalCharge)],
  ];

  if (isOwner) return baseRows;
  return [['Payment on behalf of', residentName], ...baseRows];
};


